import React from 'react';
import '../../scss/components/TextInput.scss';

interface TextInputProps {
    onChange?:any,
    onKeyDown?:any,
    placeholder?:string,
    value:string|number|null|undefined,
    name:string,
    disabled?:boolean,
    className?:string,
    wrapperClassName?:string,
    required?:boolean,
    label?:string,
    labelPosition?:string,
    readOnly?:boolean,
    ariaLabel?:string,
    type?:string,
    error?:string,
    autocomplete?:string,
    onFocus?:any,
};

const TextInput = ({
    onChange,
    onKeyDown,
    placeholder,
    value,
    name,
    disabled,
    className,
    wrapperClassName,
    required,
    label,
    labelPosition = 'before',
    readOnly,
    ariaLabel,
    type,
    error,
    autocomplete,
    onFocus
}:TextInputProps) => {
    return (
        <div className={`form-group text-input${wrapperClassName ? ' ' + wrapperClassName : ''}`}>
            { label && label.length > 0 && labelPosition === 'before' ? (
                <label htmlFor={name}>{label} {required ? '*' : ''}</label>
            ) : <></>}
            <input
                type={type ? type : 'text'}
                name={name}
                id={name}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                onChange={onChange}
                className={(className ? className : '') + (error ? ' invalid' : '')}
                aria-required={required ? 'true' : 'false'}
                readOnly={readOnly}
                aria-label={ariaLabel ? ariaLabel : (label ? label + (required ? ' (Erforderlich)' : '') : placeholder + (required ? ' (Erforderlich)' : ''))}
                autoComplete={autocomplete}
                onKeyDown={onKeyDown}
                onInvalid={e => (e.target as HTMLInputElement).setCustomValidity('Füllen Sie dieses Feld aus')}
                onInput={e => (e.target as HTMLInputElement).setCustomValidity('')}
                onFocus={onFocus}
            />
            { label && label.length > 0 && labelPosition === 'after' ? (
                <label htmlFor={name}>{label} {required ? '*' : ''}</label>
            ) : <></>}
            { error && (
                <span className='form-error' role='alert'>{ error }<br></br></span>
            ) }
        </div>
    )
}

export default TextInput;